import {
  ConsentFormSubmissionDto,
  ConsentGroupsDto,
  ConsentLinkCreationRequestDto,
  ConsentLinkDto,
  IdentitySubmissionDto,
  TermDto,
  TermGroupDto,
  TermIdentityDto,
  TermResponseDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpoint-definition';

export const consentRequests = {
  getConsentGroups: EndpointDefinition.get<TermGroupDto[], { userId: string }>({
    name: 'getConsentGroups',
    route: '/consent',
  }),
  getAllTerms: EndpointDefinition.get<TermDto[], null>({
    name: 'getAllTerms',
    route: '/consent/allTerms',
  }),
  updateConsent: EndpointDefinition.post<
    TermResponseDto[],
    TermResponseDto,
    { userId: string }
  >({
    name: 'updateConsent',
    route: '/consent',
  }),
  createConsentLink: EndpointDefinition.post<
    ConsentLinkDto,
    ConsentLinkCreationRequestDto,
    null
  >({
    name: 'createConsentLink',
    route: '/consent/links',
  }),
  getConsentLink: EndpointDefinition.get<ConsentLinkDto, { key: string }>({
    name: 'getConsentLink',
    route: '/consent/links/:key',
  }),
  getConsentForm: EndpointDefinition.get<ConsentGroupsDto, { key: string }>({
    name: 'getConsentForm',
    route: '/consent/form/',
  }),
  postIdentity: EndpointDefinition.post<
    TermIdentityDto,
    IdentitySubmissionDto,
    {}
  >({
    name: 'postIdentity',
    route: '/consent/identity',
  }),
  postIdentityForm: EndpointDefinition.post<
    TermIdentityDto,
    IdentitySubmissionDto,
    {}
  >({
    name: 'postIdentityForm',
    route: '/consent/form/identity',
  }),
  postTermForm: EndpointDefinition.post<
    ConsentGroupsDto,
    ConsentFormSubmissionDto,
    {}
  >({
    name: 'postTermForm',
    route: '/consent/form/',
  }),
};
